import { render, staticRenderFns } from "./copm-dialog.vue?vue&type=template&id=6b7cb11e&scoped=true&"
import script from "./copm-dialog.vue?vue&type=script&lang=js&"
export * from "./copm-dialog.vue?vue&type=script&lang=js&"
import style0 from "./copm-dialog.vue?vue&type=style&index=0&id=6b7cb11e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7cb11e",
  null
  
)

export default component.exports